<template>
  <header class="header__component">
    <div class="container__fw">
      <div class="container header">
        <div class="logo">
          Nirvan
          <span class="light">Pagooah</span>
        </div>
        <div class="menu">
          <div class="link">
            <a href="http://blog.nirvan.pagooah.com">Blog</a>
          </div>
          <button class="change-theme__button" @click="changeTheme">
            <transition name="switch" mode="out-in">
              <div class="dark__mode" key="dark-mode" v-if="getTheme == 'theme-1'">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.21,15.32A8.56,8.56,0,1,1,11.29,3.5a.5.5,0,0,1,.51.28.49.49,0,0,1-.09.57A6.46,6.46,0,0,0,9.8,9a6.57,6.57,0,0,0,9.71,5.72.52.52,0,0,1,.58.07A.52.52,0,0,1,20.21,15.32Z" fill="#464646"/>
                </svg>
              </div>
              <div class="light__mode" key="light-mode" v-if="getTheme == 'theme-2'">
                <svg enable-background="new 0 0 96 96" height="96px" id="sun" version="1.1" viewBox="0 0 96 96" width="96px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <path d="M81.999,14.117c1.53,1.53,1.528,4.01,0,5.539l-5.772,5.775c-1.529,1.529-4.011,1.529-5.539,0l-0.117-0.117  c-1.53-1.53-1.53-4.011-0.002-5.54L76.343,14c1.529-1.529,4.011-1.529,5.539,0L81.999,14.117z"/><path d="M48.083,0C50.246,0,52,1.754,52,3.917v8.166C52,14.246,50.246,16,48.083,16h-0.166C45.754,16,44,14.246,44,12.083V3.917  C44,1.754,45.754,0,47.917,0H48.083z"/><path d="M25.372,19.716c1.562,1.562,1.562,4.095,0,5.657l0,0c-1.562,1.562-4.095,1.562-5.656,0l-5.656-5.656  c-1.562-1.562-1.562-4.096-0.001-5.658l0,0c1.562-1.562,4.095-1.562,5.657,0.001L25.372,19.716z"/><path d="M12,44c2.209,0,4,1.791,4,4l0,0c0,2.209-1.791,4-4,4H4c-2.209,0-4-1.791-4-4l0,0c0-2.209,1.791-4,4-4H12z"/><path d="M25.432,70.688c1.53,1.529,1.529,4.008,0,5.537L19.655,82c-1.528,1.529-4.008,1.529-5.537,0l-0.119-0.118  c-1.529-1.528-1.529-4.009,0-5.538l5.775-5.775c1.529-1.528,4.01-1.528,5.539,0L25.432,70.688z"/><path d="M48.084,80C50.247,80,52,81.754,52,83.916v8.168C52,94.246,50.247,96,48.084,96h-0.168C45.753,96,44,94.246,44,92.084  v-8.168C44,81.754,45.753,80,47.916,80H48.084z"/><path d="M81.999,76.344c1.528,1.529,1.53,4.01,0,5.539L81.882,82c-1.528,1.529-4.01,1.529-5.539,0l-5.774-5.773  c-1.528-1.529-1.528-4.011,0.002-5.541l0.115-0.115c1.53-1.53,4.012-1.53,5.541-0.002L81.999,76.344z"/><path d="M92.083,44C94.246,44,96,45.754,96,47.917v0.165C96,50.246,94.246,52,92.083,52h-8.166C81.754,52,80,50.246,80,48.083  v-0.165C80,45.754,81.754,44,83.917,44H92.083z"/><path d="M24,48c0,13.255,10.745,24,24,24s24-10.745,24-24S61.255,24,48,24S24,34.745,24,48z M64,48c0,8.836-7.163,16-16,16  c-8.836,0-16-7.164-16-16c0-8.837,7.164-16,16-16C56.837,32,64,39.163,64,48z"/>
                </svg>
              </div>
            </transition>
          </button>
          <!-- <button class="menu__button">
            <img src="@/assets/menu.svg" alt />
          </button> -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  methods: {
    changeTheme () {
      this.$store.dispatch('changeTheme');
    }
  },
  computed: {
    ...mapGetters(['getTheme'])
  }
};
</script>

<style lang="scss" scoped>

.switch-enter-active, .switch-leave-active {
  transition: opacity 0.2s;
}
.switch-enter, .switch-leave-to {
  opacity: 0;
}

.header {
  height: 120px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  text-transform: uppercase;
  color: var(--color-text-dark);

  .logo {
    text-align: left;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -1px;

    .light {
      font-weight: 200;
      opacity: 0.6;
    }
  }

  .menu {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .link {
      margin-right: 20px;
      a {
        background: var(--color-blue);
        height: 40px;
        display: inline-block;
        width: 90px;
        font-size: 15px;
        color: white;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        font-weight: 400;
        border-radius: 100px;
        transition: all 0.2s ease-in-out;

        &:hover {
          box-shadow: var(--color-blue-shadow);
        }
      }
    }
    .menu__button {
      background: none;
      border: 0;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease-in-out;
      border-radius: 5px;

      img {
        height: 25px;
      }

      &:hover {
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

        img {
          transform: scale(0.9);
        }
      }
    }

    .change-theme__button {
      background: none;
      border: 0;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease-in-out;
      border-radius: 20px;

      svg {
        height: 25px;
        width: 25px;

        path {
          fill: var(--color-blue);
        }
      }
      &:hover {
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

        img {
          transform: scale(0.9);
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .header {
    height: 90px;

    .logo {
      font-size: 23px;
    }
  }
}
</style>
